import React from 'react';
import { Link } from 'react-router-dom';
import { ConnectedTranslateReviewsButton } from './translate-reviews-button';
import { useUrlLocalizer, useTranslator } from 'tradera/lang/translate';

const TabOrFilter = ({
    filterRole,
    isActive,
    text,
    largeText,
    rating,
    profileMemberId,
    alias
}) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const queryString = [
        { name: 'role', value: filterRole },
        { name: 'rating', value: rating }
    ]
        .filter(({ value }) => !!value)
        .map(({ name, value }) => `${name}=${value}`)
        .join('&');

    return (
        <li className="nav-item">
            <Link
                to={toLocalizedUrl(
                    `/profile/feedback/${profileMemberId}/${alias}${
                        queryString ? `?${queryString}` : ''
                    }`
                )}
                className={`nav-link ${isActive ? 'active' : ''}`}>
                <span className="show-xlarge">{largeText}</span>
                <span className="hide-xlarge">{text}</span>
            </Link>
        </li>
    );
};

export const FeedbackItemsHeader = ({ model }) => {
    const { t } = useTranslator();

    return (
        <>
            <ul className="nav nav-tabs nav-tabs--fullwidth">
                <TabOrFilter
                    alias={model.publicProfile.cleanedAlias}
                    profileMemberId={model.publicProfile.profileMemberId}
                    isActive={model.currentRoleFilter === 'all'}
                    text={t('profileRatingTabs_all')}
                    largeText={t('profileRatingTabs_allRatings')}
                    filterRole={null}
                    rating={null}
                />
                <TabOrFilter
                    alias={model.publicProfile.cleanedAlias}
                    profileMemberId={model.publicProfile.profileMemberId}
                    isActive={model.currentRoleFilter === 'seller'}
                    filterRole="seller"
                    text={t('profileRatingTabs_seller')}
                    largeText={t('profileRatingTabs_asSeller')}
                />
                <TabOrFilter
                    alias={model.publicProfile.cleanedAlias}
                    profileMemberId={model.publicProfile.profileMemberId}
                    isActive={model.currentRoleFilter === 'buyer'}
                    filterRole="buyer"
                    text={t('profileRatingTabs_buyer')}
                    largeText={t('profileRatingTabs_asBuyer')}
                />
                <TabOrFilter
                    alias={model.publicProfile.cleanedAlias}
                    profileMemberId={model.publicProfile.profileMemberId}
                    isActive={model.currentRoleFilter === 'leftby'}
                    filterRole="leftby"
                    text={t('profileRatingTabs_given')}
                    largeText={t('profileRatingTabs_givenRatings')}
                />
            </ul>
            <header className="p-2">
                <ul className="profile-rating-filter">
                    <li className="nav-item">
                        <strong className="profile-page-header-headline show-xlarge">
                            {t('profileRatingFilter_latestRatings')}:
                        </strong>
                        <strong className="profile-page-header-headline hide-xlarge">
                            {t('profileRatingFilter_show')}:
                        </strong>
                    </li>
                    <TabOrFilter
                        alias={model.publicProfile.cleanedAlias}
                        profileMemberId={model.publicProfile.profileMemberId}
                        filterRole={model.currentRoleFilter}
                        text={t('profileRatingFilter_all')}
                        largeText={t('profileRatingFilter_all')}
                        isActive={model.currentRatingFilter === 'all'}
                        rating={null}
                    />

                    <TabOrFilter
                        alias={model.publicProfile.cleanedAlias}
                        profileMemberId={model.publicProfile.profileMemberId}
                        filterRole={model.currentRoleFilter}
                        text={t('profileRatingFilter_positive')}
                        largeText={t('profileRatingFilter_onlyPositive')}
                        isActive={model.currentRatingFilter === 'positive'}
                        rating="positive"
                    />

                    <TabOrFilter
                        alias={model.publicProfile.cleanedAlias}
                        profileMemberId={model.publicProfile.profileMemberId}
                        filterRole={model.currentRoleFilter}
                        text={t('profileRatingFilter_negative')}
                        largeText={t('profileRatingFilter_onlyNegative')}
                        isActive={model.currentRatingFilter === 'negative'}
                        rating="negative"
                    />
                    {model.currentRatingFilter !== 'all' && (
                        <li className="pl-2">
                            {t('profileRatingFilter_fromLastPeriod')}
                        </li>
                    )}
                </ul>
                <ConnectedTranslateReviewsButton />
            </header>
        </>
    );
};
